import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Moorhead",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Moorhead Minnesota cityscape with Minnesota State University campus, Red River of the North crossing, downtown Fargo-Moorhead skyline in distance, university buildings, tree-lined residential streets, warm golden hour lighting, professional photography, no readable text or signs",
  heroImageSeq: "moorhead-mn-hero-2026",
  heroDescription:
    "Business trip to Canada crossing from Fargo-Moorhead? Student study abroad at MSU Moorhead? Family vacation to Mexico and your passport just expired? Need a first-time passport for a new job? We help Moorhead residents — from MSU Moorhead students and faculty to west central Minnesota families and Fargo-Moorhead commuters — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "46.8736; -96.7678",
  geoPlacename: "Moorhead, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/moorhead/",
  localAreaTitle: "Serving Moorhead & the Fargo-Moorhead Metro Area",
  localAreaText: [
    "Moorhead, Minnesota is a vibrant college city on the banks of the Red River of the North, directly across from Fargo, North Dakota. As the home of Minnesota State University Moorhead, the city has a youthful, international energy that sets it apart from other west central Minnesota communities. The university attracts students from around the world, creating a diverse population where international travel is a regular part of life — study abroad programs, faculty research trips, international student exchanges, and spring break travel.",
    "The Fargo-Moorhead metro area is the largest urban center between Minneapolis and Seattle, serving as a regional hub for business, healthcare, and education. Moorhead residents frequently cross the border into Canada for work, recreation, and family visits. The city is only a few hours from the Canadian border at Pembina, making passport readiness a practical necessity for many families.",
    "Moorhead's economy extends beyond the university. The city has a strong agricultural base, healthcare sector, and growing technology scene. Professionals in these industries often travel for conferences, client meetings, and trade shows. When a business trip to Toronto, a conference in Vancouver, or a family visit to Winnipeg arises, the need for a fast passport becomes urgent.",
    "The residential neighborhoods of Moorhead — from the historic districts near the university to the newer developments in the city's south and east — are filled with families, students, and professionals who need reliable passport services. Many residents commute to Fargo for work, shopping, and healthcare, creating a unique cross-state lifestyle where international travel planning is common.",
  ],
  nearbyCities: [
    { name: "Moorhead", zips: "56560, 56561, 56562, 56563" },
    { name: "Fargo, ND", zips: "58102, 58103, 58104, 58105" },
    { name: "Dilworth", zips: "56529" },
    { name: "West Fargo, ND", zips: "58078" },
    { name: "Glyndon", zips: "56547" },
    { name: "Hawley", zips: "56549" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your dorm, home, or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from Fargo-Moorhead to send your documents directly to us.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Moorhead & Fargo-Moorhead Metro Coverage",
  serviceAreaDescription: "Serving Clay County and the Fargo-Moorhead metropolitan area with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Moorhead, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Moorhead can take 2–6 months. For MSU Moorhead students with study abroad deadlines and families with international travel, that timeline is not viable.",
    },
    {
      q: "Can MSU Moorhead students get an expedited passport for study abroad?",
      a: "Absolutely. Study abroad programs are one of our most common requests from Moorhead. Many students receive their program acceptance with only 2–4 weeks before departure. We regularly process expedited first-time passports and renewals for MSU Moorhead students on compressed timelines.",
    },
    {
      q: "What if I need to cross into Canada for work or family?",
      a: "Many Moorhead residents cross the border into Canada regularly for business, family visits, or recreation. A passport is required for air travel to Canada and recommended for all border crossings. If your passport is expired or expiring, we can expedite your renewal so you do not miss work or family commitments.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Moorhead travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Moorhead. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Fargo-Moorhead area.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "MSU Moorhead Student",
      rating: 5,
      text: "I got accepted into a study abroad program in Barcelona with only three weeks before departure. My passport had expired. Fast Passport Center processed my renewal in five business days. I made my program and had an incredible semester. Their document review caught a photo issue that would have caused a delay.",
      service: "Passport Renewal",
    },
    {
      name: "The Jorgensen Family",
      location: "Moorhead, MN",
      rating: 5,
      text: "We planned a family trip to Mexico and discovered our daughter's passport had expired two weeks before departure. Fast Passport Center processed her passport in four business days. We made our trip and created wonderful memories. Thank you for the professional service.",
      service: "Child Passport",
    },
    {
      name: "Michael T.",
      location: "Moorhead, MN",
      rating: 5,
      text: "I commute to Fargo for work and received a last-minute assignment to Toronto with ten days notice. My passport was within three months of expiration. Fast Passport Center processed my renewal in four business days. I made the meeting and it went perfectly. Excellent service.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Fargo", href: "/cities/fargo" },
    { name: "St. Cloud", href: "/cities/st-cloud" },
    { name: "Duluth", href: "/cities/duluth-mn" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "Grand Forks", href: "/cities/grand-forks" },
    { name: "Bismarck", href: "/cities/bismarck" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Moorhead",
  introDescription: "Fast, reliable passport processing for Moorhead and Fargo-Moorhead metro area travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Moorhead and Fargo-Moorhead area resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Moorhead Post Office",
      address: "502 Center Ave, Moorhead, MN 56560",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(218) 236-5423",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Moorhead and Clay County residents.",
    },
    {
      name: "Fargo Main Post Office",
      address: "2101 Main Ave, Fargo, ND 58103",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(701) 241-3660",
      notes: "Convenient for Fargo-Moorhead residents. Full passport services. Photo services available. Call ahead for appointment.",
    },
    {
      name: "West Fargo Post Office",
      address: "415 Main Ave E, West Fargo, ND 58078",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(701) 282-3332",
      notes: "Serves West Fargo and west Moorhead residents. Call ahead for appointment availability.",
    },
    {
      name: "Dilworth Post Office",
      address: "1 1st Ave SE, Dilworth, MN 56529",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(218) 287-2015",
      notes: "Serves Dilworth and rural Clay County residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Moorhead", address: "201 34th St S, Moorhead, MN 56560", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Fargo", address: "2510 Broadway N, Fargo, ND 58102", hours: "Call for hours" },
    { name: "The UPS Store — Fargo", address: "3223 13th Ave S, Fargo, ND 58103", hours: "Call for hours" },
    { name: "Walgreens — Moorhead", address: "1400 30th Ave S, Moorhead, MN 56560", hours: "Call for hours" },
    { name: "FedEx Office — Fargo", address: "4302 13th Ave S, Fargo, ND 58103", hours: "Call for hours" },
    { name: "CVS Pharmacy — West Fargo", address: "855 13th Ave E, West Fargo, ND 58078", hours: "Daily 7 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Moorhead",
      address: "Moorhead area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "North Dakota DOT — Fargo",
      address: "Fargo, ND 58103",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "North Dakota option for Fargo-Moorhead residents. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FAR",
      name: "Hector International Airport",
      distance: "About 4 miles from Moorhead — 10 minutes by car",
      address: "2801 32nd Ave N, Fargo, ND 58102",
      note: "Primary commercial airport for the Fargo-Moorhead metro area. Direct service to Chicago, Denver, Minneapolis, and Phoenix. International connections through major hubs.",
      flightUrl: "https://www.fargoairport.com/",
      flightLabel: "Fargo Airport Website",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 240 miles from Moorhead — 3.5 hours by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Moorhead residents drive to MSP for international departures.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSU Moorhead Study Abroad Programs",
      subtitle: "International education opportunities for students and faculty",
      content:
        "Minnesota State University Moorhead runs active study abroad programs in Europe, Asia, and Latin America. Students frequently receive program acceptance with 2–4 weeks before departure. Spring and fall semester programs create predictable seasonal demand for passport services.",
      tip: "MSU Moorhead students should check passport expiration at least 6 months before any study abroad program. Most countries require 6 months validity beyond your return date.",
      icon: "ri-graduation-cap-line",
    },
    {
      title: "Canada Border Crossing",
      subtitle: "Regular cross-border travel for work, family, and recreation",
      content:
        "Moorhead is only hours from the Canadian border at Pembina. Many residents cross regularly for work assignments, family visits, fishing trips, and shopping. While enhanced driver's licenses work for some crossings, a passport is required for air travel and recommended for all entries.",
      tip: "Check your passport expiration before any Canadian trip. If your passport is within 6 months of expiration, renew it to avoid issues at the border.",
      icon: "ri-road-map-line",
    },
    {
      title: "Fargo-Moorhead Business Travel",
      subtitle: "Regional professionals with international clients and conferences",
      content:
        "The Fargo-Moorhead metro area is home to major employers in healthcare, technology, agriculture, and manufacturing. These professionals often travel for international conferences, client meetings, and trade shows. Business travel frequently has 2–3 weeks notice.",
      tip: "Fargo-Moorhead professionals should check passport expiration quarterly. Set calendar reminders. Business travel often has unpredictable lead times.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Family & Leisure Travel",
      subtitle: "Spring break, summer vacations, and holiday trips from the Red River Valley",
      content:
        "Moorhead families are active travelers. Spring break trips to Mexico, summer vacations in Europe, and winter cruises to the Caribbean are common. The city's strong middle-class population and university community create consistent demand for family passport services.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months before any planned travel.",
      icon: "ri-parent-line",
    },
  ],
  destinations: [
    {
      name: "Canada",
      context: "Winnipeg, Toronto, and Vancouver for business, family, and recreation",
      urgency: "Cross-border travel is frequent and often planned 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Cancun, Puerto Vallarta, and Cabo for spring break and family vacations",
      urgency: "Spring break trips and resort packages are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London, Edinburgh, and study abroad destinations",
      urgency: "Study abroad and conference schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Berlin, Munich, and Frankfurt for business and academic exchange",
      urgency: "Conference and event schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises, all-inclusive resorts, and island hopping",
      urgency: "Cruise departures and resort packages are often booked 3–6 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Spain",
      context: "Barcelona, Madrid, and study abroad programs",
      urgency: "Study abroad and academic exchange programs have fixed start dates",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "40%",
      label: "of Moorhead expedited requests are study abroad or academic travel with 2–4 weeks notice",
    },
    {
      stat: "2–4 Weeks",
      label: "average notice Moorhead travelers have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and study abroad coincide",
    },
    {
      stat: "48 Hours",
      label: "shortest emergency turnaround we have accommodated for a Moorhead student",
    },
  ],
};

export default function MoorheadPage() {
  return <CityPage data={data} />;
}